import { render } from "./IconWakeEvents.vue?vue&type=template&id=0de1eb9c"
import script from "./IconWakeEvents.vue?vue&type=script&lang=js"
export * from "./IconWakeEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__